export { default, TextSplitMap } from './TextSplitMap';